import { z } from "zod";
import { fileCategorySchema } from "./enums.js";
/** SHA-256 as lowercase hex. The file's identity, its deduplication key and its reprocessing handle. */
export const contentHashSchema = z
    .string()
    .regex(/^[0-9a-f]{64}$/, "El hash de contenido tiene que ser SHA-256 en hexadecimal.");
export const fileMetadataSchema = z.object({
    id: z.uuid(),
    contentHash: contentHashSchema,
    originalName: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    category: fileCategorySchema,
    createdAt: z.iso.datetime(),
    /**
     * True when the uploaded bytes already existed for this tenant in this category. The upload
     * succeeded and returns the existing record — Article VI rule 3 asks for this to be detected
     * and reported, not silently reprocessed and not rejected as an error.
     */
    duplicate: z.boolean(),
});
/**
 * Storage key layout: `t/<tenant_id>/<category>/<content_hash>`.
 *
 * The tenant id is the first segment so a bucket policy, a lifecycle rule or a per-tenant export
 * can be expressed without consulting the database, and so a mismatch is detectable by string
 * comparison before any network call happens.
 */
export function buildStorageKey(input) {
    return `t/${input.tenantId}/${input.category}/${input.contentHash}`;
}
/**
 * Reads the tenant segment back out of a key. Returns null when the key does not have the
 * expected shape — callers treat that as a cross-tenant access attempt rather than as a parse
 * failure, because a key that does not match the layout was not produced by this system.
 */
export function tenantIdFromStorageKey(key) {
    const parts = key.split("/");
    if (parts.length !== 4 || parts[0] !== "t")
        return null;
    const tenantId = parts[1];
    return tenantId && tenantId.length > 0 ? tenantId : null;
}
//# sourceMappingURL=files.js.map